<template>
    <section>
        <div class="side-menu-card feedback font-weight-bold" v-if="isShow" @click="goFeedback" >
            <span>Feedback</span>
            <div class="feedback-menu">
            </div>
        </div>
       
        <v-dialog
            v-model="feedbackData.dialog"
            :max-width="options.width"
            persistent
            v-bind:style="{ zIndex: options.zIndex }"
            content-class="">
            <v-form ref="forms">
                <v-card class="dialog-card">
                    <v-card-title class="title blue-title pa-3 pt-4 ml-2">
                        Feedback
                        <div class="header-close" title="close" @click="closeFeedbackDialog"><v-icon>close</v-icon></div>
                    </v-card-title>
                    <v-card-text>   
                        <v-container pt-0 px-2 fluid>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-flex xs12>
                                        <v-subheader class="pa-0 form-title">Type</v-subheader>
                                    </v-flex>
                                    <v-autocomplete 
                                                :items="AppealTypes" 
                                                v-model="AppealType" 
                                                single-line
                                                outline 
                                                :menu-props="{contentClass:'feedback-type'}"
                                                :rules="[rules.required]"
                                                ></v-autocomplete>
                                </v-flex>
                                <!-- 惩罚,投诉学生、客服 -->
                                <v-layout wrap v-if="AppealType==1||AppealType==2||AppealType==4||AppealType==9||AppealType==10||AppealType==12||AppealType==13||AppealType==36">
                                    <v-flex xs12>
                                        <v-flex xs12>
                                            <v-subheader class="pa-0 form-title">Class ID</v-subheader>
                                        </v-flex>
                                        <v-text-field v-model="ClassID"
                                                    outline
                                                    single-line
                                                    :rules="[AppealType==1?false:rules.required]"
                                                    :placeholder="AppealType==1?'If you have concerns about the salary of a certain class, please fill the Class ID.':''"
                                                    ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <v-flex xs12>
                                            <v-subheader class="pa-0 form-title">Class Time</v-subheader>
                                        </v-flex>
                                        <v-menu v-model="menu1"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="120px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="ClassTime"
                                                            readonly="readonly"
                                                            single-line
                                                            outline
                                                            :rules="[rules.required]"
                                                            v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="dateStart" 
                                                            v-show="!showStartTime"
                                                            @input="showStartTime = true" :max="currentDate"></v-date-picker>
                                            <v-time-picker v-model="At_StartTime" 
                                                            v-show="showStartTime"
                                                            @change="menu1 = false;showStartTime=false;ClassTime = formatDate(dateStart)+' '+At_StartTime" :allowed-minutes="allowedMinutes" :allowed-hours="allowedHours"></v-time-picker>
                                        </v-menu>
                                    </v-flex> -->
                                </v-layout>
                                <!-- 投诉管理人员 -->
                                <v-flex xs12 v-if="AppealType==11">
                                        <v-flex xs12>
                                            <v-subheader class="pa-0 form-title">Complaint Name</v-subheader>
                                        </v-flex>
                                        <v-text-field v-model="ComplaintName"
                                                    outline
                                                    single-line
                                                    :rules="[rules.required]"
                                                    ></v-text-field>
                                    </v-flex>
                                <v-flex xs12>
                                    <v-flex xs12>
                                            <v-subheader class="pa-0 form-title">Content</v-subheader>
                                        </v-flex>
                                    <v-textarea 
                                                v-model.trim="AppealContent" 
                                                single-line 
                                                outline 
                                                no-resize 
                                                :rules="[rules.required, rules.length]"
                                                counter="500"
                                                rows="5" 
                                                ></v-textarea>
                                   
                                    </v-flex>

                                    <v-flex xs12 sm6>
                                        <v-flex xs12>
                                                <v-subheader class="pa-0 form-title">File Upload</v-subheader>
                                            </v-flex>
                                        <v-text-field v-model="AppealFileName"
                                                        outline
                                                        single-line
                                                        readonly
                                                        :rules="[rules.required]"
                                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 pl-2>
                                        <v-btn class="text-none white--text blue-button upload-btn" @click="uploadScreenshot">
                                            <v-icon dark left>cloud_upload</v-icon>Click to Upload</v-btn>
                                        <input v-show="0"
                                                id="feedbackIdCardFile"
                                                type="file"
                                                accept=".jpg,.png,.jpeg,.gif"
                                                @change="changeScreenshot"
                                                ref="inputer">
                                    </v-flex>  
                                    <v-flex class="pink-text" v-if="remainingNum">Number of remaining fast feedback channels:{{remainingNum}}</v-flex> 
                            </v-layout>

                            <!-- <v-layout row>
                                <v-subheader class="feedback-title">
                                    File Upload
                                </v-subheader>
                                <v-flex xs5 class="feedbackIpt">
                                    <input v-show="0" type="file" class="upload" @change="changeScreenshot" ref="inputer" multiple id="feedbackIdCardFile" accept=".jpg,.png,.jpeg,.gif" />
                                    <v-text-field v-model="AppealFileName" single-line outline box class="body-2" disabled :rules="[rules.required]"></v-text-field>
                                </v-flex>
                                <v-flex xs3 pl-2 pt-0 class="feedbackIpt">
                                    <v-btn color="primary accent-4" class="text-none white--text" @click="uploadScreenshot">Select the file</v-btn>
                                </v-flex>
                            </v-layout> -->
                            <v-layout row>
                                <v-flex xs12 class="text-xs-center mt-3">
                                <v-btn class="text-none red-button dialog-submit"
                                        @click="submit"
                                        :loading="submitting"
                                        >Submit</v-btn>
                                    <v-btn class="text-none cancel-button"
                                        @click="closeFeedbackDialog"
                                        >Cancel</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                </v-card>
            </v-form>
        </v-dialog>
    </section>
</template>
<script>
import feedbackImg from '../assets/img/common/sidemenu/feedback.png' 
import { addFeedback, getFeedbackById, editFeedback, feedBackRightRemaining,GetFeeBackType } from '@/api/feedBack.js'
import store from '@/store'
import { mapGetters } from 'vuex'
import { getSelfScheduleLimitCheck } from '@/api/releaseTime'
import { _debounce } from "@/utils/tools.js";
import { uploader } from "@/utils/patchUpload.js";
import { formatDate } from '@/utils/date'

export default {
    data:()=>({
        feedbackImg:feedbackImg,
        isShow:true,
        tips:'feedback',
        show:false,
        options:{
            width: 700,
            zIndex: 200
        },
        AppealTypes: [
            // { text: 'Course Cut Payment', value: 1 }, 
            // { text: 'PAB', value: 2 },
            // { text:'Website issues',value:3},
            // { text:'Suggestion',value:4}
            // { text:'New Feature Suggestions',value:14,disabled:true},
            // { text:'Growth Center', value:18},
            // { text:'Other Features', value:19},
            // { text:'Service Fee Issues',value:1},
            // { text:'Penalties',value:2},
            // { text:'System Errors',value:3,disabled:true},
            // { text:'A-Classroom',value:4},
            // { text:'IM',value:5},
            // { text:'TutorClient',value:6},
            // { text:"Tutor's System(Web)",value:7},
            // { text:'Complaints against Students',value:8,disabled:true},
            // { text:'Not Taking Class Seriously',value:9},
            // { text:'Disrespect to the Teacher',value:10},
            // { text:'Complaint Manager',value:11},
            // { text:'Complaint Customer Service',value:12},
            // { text:'Textbook Error Corrections',value:13},
            // { text:'Commendation',value:15}
        ],
        AppealType: '',
        Appealupload: '',
        AppealContent: '',
        rules: {
            length: v => v.length <= 500 || 'Max 500 characters',
            required: v => !!v || 'Required.'
        },
        AppealFileForm: {
            files: []
        },
        AppealFileName: '',
        submitting: false,
        editFeedback: false,
        editFeedbackId : '',
        ClassID:'',
        // ClassTime:'',
        ComplaintName:'',
        dateStart: new Date().toISOString().substr(0, 10),
        currentDate:new Date().toISOString().substr(0, 10),
        menu1: false,
        At_StartTime:null,
        showStartTime:false,
        remainingNum:0
    }),
    props: {
        feedbackData: {
            dialog: false,
            id: ''
        }
    },
    created(){

  },
    mounted(){
    },
    methods:{
        goFeedback(){
            this.feedbackData.dialog = true
        },
        uploadScreenshot() {

            let flies = document.getElementById("feedbackIdCardFile")
            flies.value=''
            document.getElementById("feedbackIdCardFile").click()
        },
        changeScreenshot(elemt) {
            this.AppealFileForm.files = elemt.target.files;
            this.AppealFileName = this.AppealFileForm.files[0].name;
        },
        submit: _debounce(async function() {
            if (!this.$refs.forms.validate()) {
                return
            }
            var param = {
                Type: this.AppealType,
                Clid:this.ClassID,
                // ClassTime:this.ClassTime?new Date(this.ClassTime).toISOString():'',
                Respondents:this.ComplaintName,
                Remark: this.AppealContent
            }

            var fileArray=[]
            if(this.AppealFileForm.files && this.AppealFileForm.files.length>0){
                fileArray.push({
                    key:'appealFileFlag',
                    file:this.AppealFileForm.files
                })
            }
            if(fileArray.length>0){
                var _uploader=new uploader({
                    module: "AppealFile",
                    progressbar: this.$root.$progressbar,

                })
                
                let uploadResult = await _uploader.uploadBatchWithKey(fileArray)
                if(uploadResult.ErrorCode!=0){
                    this.$root.$alert(uploadResult.Msg||'Upload fail.')
                    return
                }
                var screenshotData = uploadResult.Body
                
                if(screenshotData && screenshotData['appealFileFlag']){
                    param.File = screenshotData['appealFileFlag'][0]
                }
                
            }
            this.submitting = true
            if(this.editFeedback) {
                param.ID = this.editFeedbackId
                this.editFeedbacks(param)
            }else{
                this.addFeedbacks(param)
            }
        }),
        addFeedbacks(param) {
            addFeedback(param).then(res => {
                let type = res.data.Body.Item1
                if(type){
                    this.$root.$alertTips(res.data.Body.Item2, 'success')
                    this.feedbackData.dialog = false
                }else{
                    this.$root.$alertTips(res.data.Body.Item2, '', { icon: { default:true } });
                }
                
            }).finally(() => {
                this.submitting = false
            })
        },
        editFeedbacks(param) {
            editFeedback(param).then(res => {
                let type = res.data.Body.Item1
                if(type){
                    this.$root.$alertTips(res.data.Body.Item2, 'success')
                    // this.feedbackData.dialog = false
                    this.closeFeedbackDialog()
                    this.editFeedback = false
                }else{
                    this.$root.$alertTips(res.data.Body.Item2, '', { icon: { default:true } });
                }
                
            }).finally(() => {
                this.submitting = false
            })
        },
        closeFeedbackDialog() {
            this.feedbackData.dialog = false
            this.feedbackData.id = ''
        },
        getFeedbackByIds(id){
            getFeedbackById(id).then(res => {
                let r = res.data.Body
                this.AppealType = r.Type
                this.AppealContent = r.Remark
                this.AppealFileName = r.FileUrl
                this.editFeedback = true
                this.editFeedbackId = id
            }).finally(() => {
                
            })
        },
        allowedMinutes: v => v == 0 || v == 30,
        allowedHours:function (v){
            if(this.formatDate(this.dateStart)==this.formatDate(this.currentDate)){
                return v <= new Date().getHours()
            }
            return v>=0
        },
        feedBackRightRemainingNum(){
            feedBackRightRemaining().then(res=>{
                if(res.data.ErrorCode===0){
                    this.remainingNum = res.data.Body
                }
            })
        },
        formatDate(date){
            return formatDate(date,'MM/dd/yyyy');
        },
    },
    computed: {
        ...mapGetters([
        'user'
        ])
    },

    watch:{
        'feedbackData.dialog': function (value, oldValue) {
            if (value !== oldValue) {
                this.$refs.forms.resetValidation()
                this.AppealType = ''
                this.AppealContent = ''
                this.AppealFileName = ''
                this.AppealFileForm = {}
                this.ComplaintName = ''
                this.ClassID = ''
            }
            if(value){
                this.feedBackRightRemainingNum()
                GetFeeBackType().then(res=>{
                    if(res.data.Body&&res.data.Body.length>0){
                    let arr=[]
                    res.data.Body.forEach(item=>{
                        let obj={}
                        Object.keys(item).forEach((key,ind)=>{
                        let val=key.replace(key[0],key[0].toLowerCase())
                        obj[val]=item[key]
                        })
                        arr.push(obj)
                    })
                    this.AppealTypes=arr
                    }
                })
            }
        },
        'feedbackData.id': {
            handler:function(value) {   
                if(value){
                    this.getFeedbackByIds(value)
                     
                }
            },
            deep: true
        }
    }
}
</script>
<style lang="scss">
.feedback-type.v-menu__content{
    div[role=list]{
        div[role=listitem]:nth-child(2),
        div[role=listitem]:nth-child(3),
        div[role=listitem]:nth-child(7),
        div[role=listitem]:nth-child(8),
        div[role=listitem]:nth-child(9),
        div[role=listitem]:nth-child(10),
        div[role=listitem]:nth-child(12),
        div[role=listitem]:nth-child(13){
            margin-left:20px !important;
        }
    }
}

</style>